import * as React from 'react';
import { useEffect, useState } from 'react';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import useStyles from '../maintenance/assets/styles';
import { useHistory } from 'react-router-dom';
import { Grid, Card, Box, Typography, Divider } from '@material-ui/core';
import { PopUpOpenIcon, TemplateIcon } from 'src/components/Icons';
import { DialogPopup } from '../maintenance/test-automation/components/DialogPopup';
import { defineTestCasesBulk, fetchBatchNumbers, getRecentTestIotGroups, getSimilarMaintestCases, getTestIoTCategories, getTestIotGroups, getTestIoTTemplate, matchSensorNames, startTestingBulk } from '../maintenance/test-automation/components/apiHelper';
import { TestingStepComponent } from './components/TestingStepComponent';
import { convertToMinutes, periodMap } from '../utils';
import { formatDateString } from '../testing-automation/api-helper/apiHelper';
import { ToasterComponent } from '../maintenance/test-automation/components/Toaster';
import { min, set } from 'date-fns';
import { Loader } from '../maintenance/test-automation/components/Loader';

export const TestIoTComponent = (props) => {
    const theme = createTheme({
        typography: {
            fontFamily: "'Poppins', sans-serif",
        },
    });
    const classes = useStyles();
    const history = useHistory();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [testGroups, setTestGroups] = useState([]);
    const [testCategories, setTestCategories] = useState([]);
    const [recentTestGroups, setRecentTestGroups] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [selectedSubTestCases, setSelectedSubTestCases] = useState({});
    const [templateData, setTemplateData] = useState([]);
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [selectedBatch, setSelectedBatch] = useState('');
    const [selectedParameters, setSelectedParameters] = useState({});
    const [modifiedValues, setModifiedValues] = useState({});
    const [parameters, setParameters] = useState([]);
    const [step, setStep] = useState(0);
    const [responseTime, setResponseTime] = useState("");
    const [selectedPeriod, setSelectedPeriod] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndtDate, setSelectedEndtDate] = useState(new Date());
    const [definedTestCases, setDefinedTestCases] = useState([]);
    const [testCaseTypes, setTestCaseTypes] = useState([
        "Production Feasibility Testing", "Continuous Testing"
    ]);
    const [shedulePeriod, setShedulePeriod] = useState([
        "Minutes", "Hours", "Days"
    ]);
    const [selectedTestCaseType, setSelectedTestCaseType] = useState("");
    const [errors, setErrors] = useState({
        rootCauseNotificationDurationInMinutes: null,
        batchNoError: null,
        period: null,
        testingMethodError: null,
        mainTestNameError: null,
        subTestCaseError: null,
        startDateError: null,
        endDateError: null,
        parameterError: null,
        minValError: null,
        maxValError: null,
        responseTimeError: null,
    });

    //Toaster
    const [isToasterOpen, setIsToasterOpen] = useState(false)
    const [toasterMessage, setToasterMessage] = useState("")
    const [reqSuccess, setReqSuccess] = useState(false)
    const [loading, setLoading] = useState(false)

    const searchParams = new URLSearchParams(location.search);
    const initialBatch = searchParams.get('batch');
    const initialStreamingMethod = searchParams.get('streamingMethod');

    useEffect(() => {
        if (initialBatch) {
            setSelectedBatch(initialBatch);
        }
    }, [initialBatch]);

    useEffect(() => {
        const getBatchNumbers = async () => {
            try {
                const batchNumbers = await fetchBatchNumbers();
                setBatchNumbers(batchNumbers);
            } catch (err) {
                console.error('Error fetching batch numbers:', err);
            }
        };
        getBatchNumbers();
    }, []);

    useEffect(() => {
        const getParameters = async () => {
            try {
                if (!selectedBatch) return;
                
                const parameters = await matchSensorNames(selectedBatch);
                setParameters(parameters);

                setTemplateData(prevTemplates => {
                    if (!prevTemplates) return prevTemplates;
                    
                    const newSelectedParameters = {...selectedParameters};
                    let hasChanges = false;

                    prevTemplates.forEach((template, templateIndex) => {
                        template.subTestCases.forEach((subCase, subIndex) => {
                            const paramKey = `${templateIndex}-${subIndex}`;
                            
                            if (subCase.sensorCode && !selectedParameters[paramKey]) {
                                const matchedParam = parameters.find(p => p.code === subCase.sensorCode);
                                
                                if (matchedParam) {
                                    newSelectedParameters[paramKey] = {
                                        label: matchedParam.name,
                                        value: matchedParam.code
                                    };
                                    hasChanges = true;
                                }
                            }
                        });
                    });

                    if (hasChanges) {
                        setSelectedParameters(newSelectedParameters);
                    }
                    
                    return prevTemplates;
                });
            } catch (err) {
                console.error('Error fetching parameters:', err);
            }
        };

        getParameters();
    }, [selectedBatch]);

    const parameterOptions = parameters.map(param => ({
        label: param.name,
        value: param.code   
    }));

    const fetchTestIotGroups = async () => {
        setLoading(true);
        try {
            const response = await getTestIotGroups();
            if (response) setTestGroups(response);
        } catch (error) {
            console.error("Error fetching test IoT groups:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchTestToTCategories = async () => {
        setLoading(true);
        try {
            const response = await getTestIoTCategories();
            if (response) setTestCategories(response);
        } catch (error) {
            console.error("Error fetching test categories:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchRecentTestIoTGroups = async () => {
        setLoading(true);
        try {
            const response = await getRecentTestIotGroups();
            if (response) setRecentTestGroups(response);
        } catch (error) {
            console.error("Error fetching recent test IoT groups:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTestToTCategories();
        fetchTestIotGroups();
        fetchRecentTestIoTGroups();
    }, []);

    const getGroupsByCategory = (categoryId) => {
        return testGroups.filter((group) => group.categoryId === categoryId);
    };

    const handleSelectBatchNumber = (value) => {
        setSelectedBatch(value);
        setErrors((prevErrors) => ({
            ...prevErrors,
            batchNoError: null
        }));
    }

    const handleCheckboxChange = (templateIndex, subIndex, isChecked) => {
        setSelectedSubTestCases(prev => ({
            ...prev,
            [`${templateIndex}-${subIndex}`]: isChecked
        }));
        setErrors(prev => ({
            ...prev,
            subTestCaseError: null
        }));
    };

    const handleValueChange = (templateIndex, subIndex, field, value) => {
        if (field === 'minVal' || field === 'maxVal') {
            if (/^-?\d*\.?\d*$/.test(value)) {
                setModifiedValues(prev => ({
                    ...prev,
                    [`${templateIndex}-${subIndex}-${field}`]: value
                }));

                setTemplateData(prev => {
                    const updated = [...prev];
                    updated[templateIndex].subTestCases[subIndex][field] = value;
                    return updated;
                });

                setErrors(prev => ({ ...prev, [`${field}Error`]: null }));
            }
        }
    };

    const handlePopupOpen = async (group) => {
        try {
            const response = await getTestIoTTemplate(group.id);
            if (response) {
                setTemplateData(response);
                setSelectedTemplate({ id: group.id, title: group.groupName });
                setIsPopupOpen(true);
                
                let initialParams = {};
                const parameters = selectedBatch ? await matchSensorNames(selectedBatch) : [];
                
                response.forEach((template, tIdx) => {
                    template.subTestCases.forEach((subCase, sIdx) => {
                        const paramKey = `${tIdx}-${sIdx}`;
                        
                        if (subCase.sensorCode) {
                            const matchedParam = parameters.find(p => p.code === subCase.sensorCode);
                            if (matchedParam) {
                                initialParams[paramKey] = {
                                    label: matchedParam.name,
                                    value: matchedParam.code
                                };
                            } else {
                                initialParams[paramKey] = null;
                            }
                        } else {
                            initialParams[paramKey] = null;
                        }
                    });
                });
                
                setSelectedParameters(initialParams);
                setParameters(parameters);
            }
        } catch (error) {
            console.error("Error fetching template data:", error);
        }
    };

    const handlePopupClose = () => {
        setSelectedTemplate(null);
        setIsPopupOpen(false);
        setStep(0);
        setSelectedBatch('');
        setSelectedSubTestCases({});
    };

    const handleBack = () => {
        setStep(0);
    };

    const handleIncrease = () => {
        const currentValue = responseTime === '' ? 0 : parseInt(responseTime, 10);
        setResponseTime(String(currentValue + 1));
        setErrors((prevError) => ({
          ...prevError,
          rootCauseNotificationDurationInMinutes: null
        }));
    };


    const handleDecrease = () => {
        const currentValue = responseTime === '' ? 0 : parseInt(responseTime, 10);
        setResponseTime(currentValue > 0 ? String(currentValue - 1) : '0');
        setErrors((prevError) => ({
          ...prevError,
          rootCauseNotificationDurationInMinutes: null
        }));
    };

    const handleResponseTime = (value: number | string) => {
        const stringValue = String(value);
        const numericValue = stringValue.replace(/[^0-9]/g, '');

        setResponseTime(numericValue);

          setErrors((prevError) => ({
            ...prevError,
            rootCauseNotificationDurationInMinutes: null
          }));
    };

    const handleStartDateChange = (e) => {
        const newStartDate = formatDateString(e);
        setSelectedStartDate(e)
        if (newStartDate > endDate) {
          setEndDate("");
          setSelectedEndtDate(new Date())
        }
        setStartDate(newStartDate);
        setErrors((prevError) => ({
            ...prevError,
            startDateError: null
        }));
    };
      
    const handleEndDateChange = (e) => {
        const newEndDate = formatDateString(e);
        setSelectedEndtDate(e)
        if (newEndDate < startDate) {
            setStartDate("");
            setSelectedStartDate(new Date())
        }
        setEndDate(newEndDate);
        setErrors((prevError) => ({
            ...prevError,
            endDateError: null
        }));
    };

    const handleSchedulePeriod = (period) => {
        const periodInMinutes = convertToMinutes(parseInt(responseTime), period);
        setSelectedPeriod(periodMap[period]);

          setErrors((prevError) => ({
            ...prevError,
            period: null
          }));
    };

    const handleSelectTestingMethod = (value) => {
        setSelectedTestCaseType(value);
        setErrors((prevErrors) => ({
            ...prevErrors,
            testingMethodError: null
        }));
    };

    const handleParameterChange = (templateIndex, subIndex, selectedValue) => {
        const selectedParameter = parameterOptions.find(opt => opt.value === selectedValue);
    
        setTemplateData(prev => {
            const updated = [...prev];
            updated[templateIndex] = {
                ...updated[templateIndex],
                subTestCases: updated[templateIndex].subTestCases.map((subCase, idx) => 
                    idx === subIndex
                        ? { ...subCase, sensorCode: selectedParameter.value }
                        : subCase
                )
            };
            return updated;
        });

        setSelectedParameters(prev => ({
            ...prev,
            [`${templateIndex}-${subIndex}`]: selectedParameter
        }));

        setErrors(prev => ({
            ...prev,
            parameterError: null
        }));
    };

    const validationForm = () => {
        let isValid = true;
        const newErrors = {
            rootCauseNotificationDurationInMinutes: null,
            batchNoError: null,
            period: null,
            testingMethodError: null,
            mainTestNameError: null,
            subTestCaseError: null,
            startDateError: null,
            endDateError: null,
            parameterError: null,
            minValError: null,
            maxValError: null,
            responseTimeError: null,
        };

        if (step === 0) {
            if (!selectedBatch) {  
                newErrors.batchNoError = "Batch number is required";
                isValid = false;
            }

            const hasSelected = Object.values(selectedSubTestCases).some(val => val);
            if (!hasSelected) {
                newErrors.subTestCaseError = "Select at least one sub test case is required";
                isValid = false;
            }

            for (let tIdx = 0; tIdx < templateData.length; tIdx++) {
                const template = templateData[tIdx];
                for (let sIdx = 0; sIdx < template.subTestCases.length; sIdx++) {
                    const subCase = template.subTestCases[sIdx];
                    
                    if (selectedSubTestCases[`${tIdx}-${sIdx}`]) {
                        const paramKey = `${tIdx}-${sIdx}`;
                        
                        if (!selectedParameters[paramKey]) {
                            newErrors.parameterError = "Parameter is Required";
                            isValid = false;
                        }

                        if (subCase.successCriteria === "IS_BETWEEN") {
                            const minVal = modifiedValues[`${tIdx}-${sIdx}-minVal`];
                            const maxVal = modifiedValues[`${tIdx}-${sIdx}-maxVal`];
                            
                            if (minVal === '') {
                                newErrors.minValError = "Value is required";
                                isValid = false;
                            }
                            if ( maxVal === '') {
                                newErrors.maxValError = "Value is required";
                                isValid = false;
                            }

                        } else {
                            if (subCase.successCriteria && subCase.successCriteria !== "IS_BETWEEN") {
                                let val;
                                if (modifiedValues[`${tIdx}-${sIdx}-minVal`] !== undefined) {
                                    val = modifiedValues[`${tIdx}-${sIdx}-minVal`];
                                } else {
                                    val = subCase.minVal;
                                }

                                if( val === '' || val === undefined) {
                                    newErrors.minValError = "Value is required";
                                    isValid = false;
                                }
                            }
                        }
                    }
                }
            }
        }
        if (step === 1) {
            if (selectedTestCaseType === "") {
                newErrors.testingMethodError = "Testing Method is Required";
                isValid = false;
            }

            if (selectedTestCaseType === "Continuous Testing") {
                if (responseTime === "") {
                    newErrors.rootCauseNotificationDurationInMinutes = "Time is required";
                    isValid = false;
                }
                if (selectedPeriod === "") {
                    newErrors.period = "Period is required";
                    isValid = false;
                }
            }

            if (selectedTestCaseType === "Production Feasibility Testing") {
                if (endDate === "") {
                    newErrors.endDateError = "End Date and Time is required";
                    isValid = false;
                }
                if (startDate === "") {
                    newErrors.startDateError = "Start Date and Time is required";
                    isValid = false;
                }
            }
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleDefineTesting = async () => {
        try {
            setLoading(true);
            
            const existingCasesPromises = templateData.map(async (template) => {
                try {
                    const similarCases = await getSimilarMaintestCases(selectedBatch, template.mainTestTitle);
                    return { 
                        template, 
                        existingCount: similarCases.length,
                        existingTitles: similarCases.map(c => c.mainTestTitle)
                    };
                } catch (error) {
                    console.error("Error checking similar test cases:", error);
                    return { template, existingCount: 0, existingTitles: [] };
                }
            });

            const existingCasesResults = await Promise.all(existingCasesPromises);
            
            const payload = templateData.reduce((acc, template, tIdx) => {
                const result = existingCasesResults.find(r => r.template === template);
                let mainTestTitle = template.mainTestTitle;
                
                if (result && result.existingCount > 0) {
                    let maxNumber = 0;
                    const regex = /\((\d+)\)$/;
                    
                    result.existingTitles.forEach(title => {
                        const match = title.match(regex);
                        if (match) {
                            const num = parseInt(match[1], 10);
                            if (num > maxNumber) maxNumber = num;
                        } else if (title === mainTestTitle) {
                            maxNumber = Math.max(maxNumber, 1);
                        }
                    });
                    
                    if (maxNumber > 0) {
                        mainTestTitle = `${template.mainTestTitle} (${maxNumber + 1})`;
                    } else {
                        mainTestTitle = `${template.mainTestTitle} (1)`;
                    }
                }

                const selectedSubCases = template.subTestCases.reduce((subAcc, subCase, sIdx) => {
                    if (!selectedSubTestCases[`${tIdx}-${sIdx}`]) {
                        return subAcc;
                    }

                    let sensorCode: string | null = null;
                    
                    if (subCase.sensorCode) {
                        sensorCode = subCase.sensorCode;
                    }
                    
                    if (!sensorCode) {
                        const selectedParam = selectedParameters[`${tIdx}-${sIdx}`];
                        if (selectedParam && selectedParam.value) {
                            sensorCode = selectedParam.value;
                        }
                    }

                    subAcc.push({
                        id: subCase.id,
                        minVal: subCase.minVal,
                        maxVal: subCase.maxVal,
                        valueType: subCase.valueType,
                        subTestTitle: subCase.subTestTitle,
                        batchNumber: selectedBatch,
                        status: subCase.status,
                        successCriteria: subCase.successCriteria,
                        sensorReadingDuration: subCase.sensorReadingDuration,
                        subSuccessCriteria: subCase.subSuccessCriteria,
                        referenceId: subCase.referenceId,
                        default: subCase.default,
                        sensorCode: sensorCode
                    });

                    return subAcc;
                }, [] as any[]);

                if (selectedSubCases.length > 0) {
                    acc.push({
                        batchNumber: selectedBatch,
                        mainTestTitle: mainTestTitle,
                        subTestCases: selectedSubCases,
                        subTestCasesIdList: selectedSubCases.map(sub => sub.id),
                        description: template.description,
                        dataStreamingMethod: "SENZMATE"
                    });
                }

                return acc;
            }, [] as any[]);

            const response = await defineTestCasesBulk(payload, selectedTemplate.id);
            setDefinedTestCases(response);
            setToasterMessage("Test case defined successfully");
            setIsToasterOpen(true);
            setReqSuccess(true);
            setStep(1);
        } catch (error) {
            console.error("Error creating test cases:", error);
            setToasterMessage(error instanceof Error ? error.message : "Failed to create test cases");
            setIsToasterOpen(true);
            setReqSuccess(false);
        } finally {
            setLoading(false);
            setTimeout(() => {
                setIsToasterOpen(false);
            }, 3000);
        }
    };

    const handleStartTesting = async () => {
        try {
            setLoading(true);

            const startTestingBasicData = definedTestCases.map(testCase => ({
                batchNumber: testCase.batchNumber,
                status: testCase.status,
                checked: testCase.checked,
                mainTestTitle: testCase.mainTestTitle,
                subTestCases: testCase.subTestCases.map(subCase => ({
                    id: subCase.id,
                    minVal: subCase.minVal,
                    maxVal: subCase.maxVal,
                    valueType: subCase.valueType,
                    subTestTitle: subCase.subTestTitle,
                    batchNumber: subCase.batchNumber,
                    status: subCase.status,
                    successCriteria: subCase.successCriteria,
                    sensorCode: subCase.sensorCode,
                    sensorReadingDuration: subCase.sensorReadingDuration,
                    subSuccessCriteria: subCase.subSuccessCriteria,
                    referenceId: subCase.referenceId,
                    default: subCase.default
                })),
                subTestCasesIdList: testCase.subTestCasesIdList,
                devices: testCase.devices,
                dataStreamingMethod: testCase.dataStreamingMethod,
                description: testCase.description
            }));

            let payload;
            
            if (selectedTestCaseType === "Production Feasibility Testing") {
                payload = startTestingBasicData.map(testCase => ({
                    ...testCase,
                    startDate: formatDateString(selectedStartDate),
                    endDate: formatDateString(selectedEndtDate)
                }));
            } else {
                payload = startTestingBasicData.map(testCase => ({
                    ...testCase,
                    testCaseType: "CONTINUOUS",
                    continuousTestEndType: "NEVER",
                    rootCauseNotificationDurationInMinutes: convertToMinutes(parseInt(responseTime), selectedPeriod),
                    period: selectedPeriod
                }));
            }

            const response = await startTestingBulk(payload);
            setToasterMessage("Testing started successfully");
            setIsToasterOpen(true);
            setReqSuccess(true);
            setSelectedBatch('');
            setSelectedTestCaseType('');
            setResponseTime('');
            setSelectedPeriod('');
            setSelectedTemplate(null);
            setIsPopupOpen(false);
            setStep(0);
        } catch (error) {
            console.error("Error starting testing:", error);
            setToasterMessage(error instanceof Error ? error.message : "Failed to start testing");
            setIsToasterOpen(true);
            setReqSuccess(false);
        } finally {
            setLoading(false);
            setTimeout(() => {
                setIsToasterOpen(false);
            }, 3000);
        } 
    };

    const handleNext = () => {
        const isValid = validationForm();
        if (!isValid) {
            return;
        }
        if (step === 0) {
            handleDefineTesting();
        } else if (step === 1) {
            handleStartTesting();
        }
    }

    return (
        <ThemeProvider theme={theme}>
            <Grid container style={{ padding: "25px", margin: "0px" }}>
                <Grid className={classes.pageTitle} style={{ margin: "0px" }}>
                    Test IoT Lab
                </Grid>


                <Grid item xs={12} md={12}>
                    <Typography className={classes.cardPageTitle}>
                        Recently Used Templates
                    </Typography>
                    {recentTestGroups.length > 0 ? (
                        <Grid container spacing={3} className={classes.cardsContainer}>
                            {recentTestGroups.map((template) => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={template.id}>
                                    <Card
                                        className={classes.templateCard}
                                        onClick={() => handlePopupOpen(template)}
                                    >
                                        <Box className={classes.hoverOverlay}>
                                            <Box className={classes.hoverIcon}>
                                                <PopUpOpenIcon />
                                            </Box>
                                        </Box>

                                        <Box className={classes.iconSection}>
                                            <TemplateIcon />
                                        </Box>

                                        <Divider className={classes.dividerLine} />

                                        <Box className={classes.contentSection}>
                                            <Typography className={classes.templateTitle}>
                                                {template.groupName}
                                            </Typography>
                                            <Typography className={classes.templateContent}>
                                                {template.groupDescription}
                                            </Typography>
                                        </Box>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    ) : (
                        <Typography className={classes.templateContent} style={{ padding: "10px 0px"}}>
                            No recently used templates available.
                        </Typography>
                    )}
                </Grid>

                {testCategories.map((category) => {
                    const groups = getGroupsByCategory(category.id);
                    if (groups.length === 0) return null;

                    return (
                        <Grid item xs={12} md={12} key={category.id}>
                            <Typography className={classes.cardPageTitle}>
                                {category.categoryName}
                            </Typography>
                            <Grid container spacing={3} className={classes.cardsContainer}>
                                {groups.map((group) => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={group.id}>
                                        <Card
                                            className={classes.templateCard}
                                            onClick={() => handlePopupOpen(group)}
                                        >
                                            <Box className={classes.hoverOverlay}>
                                                <Box className={classes.hoverIcon}>
                                                    <PopUpOpenIcon />
                                                </Box>
                                            </Box>

                                            <Box className={classes.iconSection}>
                                                <TemplateIcon />
                                            </Box>

                                            <Divider className={classes.dividerLine} />

                                            <Box className={classes.contentSection}>
                                                <Typography className={classes.templateTitle}>
                                                    {group.groupName}
                                                </Typography>
                                                <Typography className={classes.templateContent}>
                                                    {group.groupDescription}
                                                </Typography>
                                            </Box>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>

            <DialogPopup
                open={isPopupOpen}
                onClose={handlePopupClose}
                title={selectedTemplate ? selectedTemplate.title : ''}
                dialogWidth={'1530px'}
                buttonRequired={false}
                dialogContent={
                    <TestingStepComponent
                        groupId={selectedTemplate ? selectedTemplate.id : ''}
                        templates={templateData}
                        parameterOptions={parameterOptions}
                        selectedParameters={selectedParameters}
                        handleParameterChange={handleParameterChange}
                        batchNumbers={batchNumbers}
                        handleSelectBatchNumber={handleSelectBatchNumber}
                        selectedBatch={selectedBatch}
                        handlePopupClose={handlePopupClose}
                        step={step}
                        errors={errors}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        testCaseTypes={testCaseTypes}
                        selectedTestCaseType={selectedTestCaseType}
                        handleSelectTestingMethod={handleSelectTestingMethod}
                        responseTime={responseTime}
                        handleResponseTime={handleResponseTime}
                        handleIncrease={handleIncrease}
                        handleDecrease={handleDecrease}
                        shedulePeriod={shedulePeriod}
                        selectedPeriod={selectedPeriod}
                        handleSchedulePeriod={handleSchedulePeriod}
                        selectedSubTestCases={selectedSubTestCases}
                        handleCheckboxChange={handleCheckboxChange}
                        handleValueChange={handleValueChange}
                        modifiedValues={modifiedValues}
                        selectedStartDate={selectedStartDate}
                        handleStartDateChange={handleStartDateChange}
                        selectedEndtDate={selectedEndtDate}
                        handleEndDateChange={handleEndDateChange}
                        definedTestCases={definedTestCases}
                        initialBatch={initialBatch}
                        initialStreamingMethod={initialStreamingMethod}
                    />
                }
            />
            <ToasterComponent
                toaster={isToasterOpen}
                message={toasterMessage}
                reqSuccess={reqSuccess}
            />
            <Loader loading={loading} />
        </ThemeProvider >
    );
}

